import { usePlan } from "@/features/auth";
import {
  NOTIFICATION_CONFIGS,
  hasFeatureAccess,
} from "@/features/notifications/config/notification.config";
import { useNotificationsContext } from "@/features/notifications/context/NotificationsContext";

export const useVisibleNotifications = () => {
  const { notifications, isLoading, isError } = useNotificationsContext();
  const plan = usePlan();

  if (!notifications) {
    return {
      visibleNotifications: [],
      isLoading,
      isError,
      hasNotifications: false,
    };
  }

  const visibleNotifications = NOTIFICATION_CONFIGS.filter((config) => {
    const notificationData = notifications[config.key];
    const hasNotifications = notificationData && notificationData.count > 0;
    const hasAccess = hasFeatureAccess(config.key, plan);

    return hasNotifications && hasAccess;
  });

  return {
    visibleNotifications,
    isLoading,
    isError,
    hasNotifications: visibleNotifications.length > 0,
  };
};
